import {
  // -- GET (list)
  GET_GLOBAL_RESOURCES_SUCCESS,
  GET_GLOBAL_RESOURCES_FAILURE,
  // -- CREATE
  CREATE_GLOBAL_RESOURCE_SUCCESS,
  CREATE_GLOBAL_RESOURCE_FAILURE,
  // -- UPDATE
  UPDATE_GLOBAL_RESOURCE_SUCCESS,
  UPDATE_GLOBAL_RESOURCE_FAILURE,
  // -- DELETE
  DELETE_GLOBAL_RESOURCE_SUCCESS,
  DELETE_GLOBAL_RESOURCE_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

export const globalResources = (state = {}, action) => {
  switch (action.type) {
    // -- GET GLOBAL RESOURCES (list)
    case GET_GLOBAL_RESOURCES_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalResources.GET_GLOBAL_RESOURCES_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_GLOBAL_RESOURCES_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalResources.GET_GLOBAL_RESOURCES_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE GLOBAL RESOURCE
    case CREATE_GLOBAL_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalResources.CREATE_GLOBAL_RESOURCE_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_GLOBAL_RESOURCE_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalResources.CREATE_GLOBAL_RESOURCE_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE GLOBAL RESOURCE
    case UPDATE_GLOBAL_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalResources.UPDATE_GLOBAL_RESOURCE_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_GLOBAL_RESOURCE_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalResources.UPDATE_GLOBAL_RESOURCE_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- DELETE GLOBAL RESOURCE
    case DELETE_GLOBAL_RESOURCE_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] globalResources.DELETE_GLOBAL_RESOURCE_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_GLOBAL_RESOURCE_SUCCESS: {
      const newItems = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] globalResources.DELETE_GLOBAL_RESOURCE_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    default:
      return state
  }
}
